// Angular
import { Component, ElementRef, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'kt-template-edit-dialog',
  templateUrl: './template-edit-dialog.html',
})
export class TemplateEditDialogComponent implements OnInit {
  // Public properties
  viewLoading = false;
  @ViewChild('confirmButton') confirmButton: ElementRef;
  @ViewChild('cancelButton') cancelButton: ElementRef;
  focusedButton = 'confirm';

  constructor(
    public dialogRef: MatDialogRef<TemplateEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    window.addEventListener('message', (params) => {
      if (params.origin !== 'https://app.boldsign.com') {
        return;
      }

      switch (params.data.status) {
        case 'OnDraftSavedSuccess':
          this.dialogRef.close(true);
          break;
        case 'onDraftFailed':
          // handle draft failure
          break;
        case 'onCreateSuccess':
          this.dialogRef.close(true);
          break;
        case 'onCreateFailed':
          // handle create failure
          break;
        case 'onTemplateEditingCompleted':
          this.dialogRef.close(true);
          break;
        case 'onTemplateEditingFailed':
          // handle edit failure
          break;
        default:
          break;
      }
    });
  }
  @HostListener('window:keydown.enter', ['$event'])
  @HostListener('window:keydown.arrowleft', ['$event'])
  @HostListener('window:keydown.arrowright', ['$event'])
  onEnterKey(event: KeyboardEvent) {
    if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
      event.preventDefault(); // prevent default browser scrolling behavior
      this.focusedButton = this.focusedButton === 'confirm' ? 'cancel' : 'confirm';
    } else if (event.key === 'Enter') {
      if (this.focusedButton === 'confirm') {
        this.onYesClick();
      } else {
        this.onNoClick();
      }
    }
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  onYesClick(): void {
    this.dialogRef.close(true);
  }
}
